import moment from 'moment';
import { createStaticRanges } from 'react-date-range';
import { subDays } from 'date-fns';

export enum ReportDateFilter {
  This_Week = 'This Week',
  Last_Week = 'Last Week',
  This_Month = 'This Month',
  Last_Month = 'Last Month',
  Last_Three_Months = 'Last 3 Months',
  Last_SIX_Months = 'Last 6 Months',
  This_Year = 'This Year',
  Last_Year = 'Last Year',
  TODAY = 'Today',
  CUSTOM_DATE = 'Custom Date',
}

export enum DateFilter {
  This_Week = 'This Week',
  Last_Week = 'Last Week',
  This_Month = 'This Month Till Date',
  Last_Month = 'Last Month',
  This_Qtr = 'This QTR Till Date',
  Last_Qtr = 'Last QTR',
  TODAY = 'Today',
  YESTERDAY = 'Yesterday',
  CUSTOM_DATE = 'Custom Date',
  This_Year = 'This Year Till Date',
  Last_Year = 'Last Year',
}

const getQuarterDates = (today: Date) => {
  const month = today.getMonth() + 1;
  const year = today.getFullYear();

  let thisQuarterStartMonth, lastQuarterStartMonth;
  let lastQuarterYear = year;
  if (month >= 4 && month <= 6) {
    thisQuarterStartMonth = 4;
    lastQuarterStartMonth = 1;
  } else if (month >= 7 && month <= 9) {
    thisQuarterStartMonth = 7;
    lastQuarterStartMonth = 4;
  } else if (month >= 10 && month <= 12) {
    thisQuarterStartMonth = 10;
    lastQuarterStartMonth = 7;
  } else {
    thisQuarterStartMonth = 1;
    lastQuarterStartMonth = 10;
    lastQuarterYear = year - 1;
  }
  const thisQuarterStartDate = new Date(year, thisQuarterStartMonth - 1, 1);
  const thisQuarterEndDate = today;
  const lastQuarterStartDate = new Date(
    lastQuarterYear,
    lastQuarterStartMonth - 1,
    1
  );
  const lastQuarterEndDate = new Date(year, thisQuarterStartMonth - 1, 0);

  return {
    thisQuarterDate: {
      startDate: thisQuarterStartDate,
      endDate: thisQuarterEndDate,
    },
    lastQuarterDate: {
      startDate: lastQuarterStartDate,
      endDate: lastQuarterEndDate,
    },
  };
};

export const ReportsDateDefaultOptionsArray = [
  {
    label: DateFilter.TODAY,
    dateTime: {
      startDate: new Date(moment().format('YYYY-MM-DD')),
      endDate: new Date(moment().format('YYYY-MM-DD')),
    },
  },
  {
    label: DateFilter.YESTERDAY,
    dateTime: {
      startDate: new Date(moment().subtract(1, 'days').format('YYYY-MM-DD')),
      endDate: new Date(moment().subtract(1, 'days').format('YYYY-MM-DD')),
    },
  },
  {
    label: DateFilter.This_Week,
    dateTime: {
      startDate: new Date(moment().startOf('week').toDate()),
      endDate: new Date(moment().format('YYYY-MM-DD')),
    },
  },
  {
    label: DateFilter.Last_Week,
    dateTime: {
      startDate: new Date(
        moment().subtract(1, 'weeks').startOf('week').add(1, 'days').toDate()
      ),
      endDate: new Date(
        moment().subtract(1, 'weeks').endOf('week').add(1, 'days').toDate()
      ),
    },
  },
  {
    label: DateFilter.This_Month,
    dateTime: {
      startDate: new Date(moment().startOf('month').toDate()),
      endDate: new Date(moment().format('YYYY-MM-DD')),
    },
  },
  {
    label: DateFilter.Last_Month,
    dateTime: {
      startDate: new Date(
        moment().clone().subtract(1, 'month').startOf('month').toDate()
      ),
      endDate: new Date(
        moment().clone().subtract(1, 'month').endOf('month').toDate()
      ),
    },
  },
  {
    label: DateFilter.This_Qtr,
    dateTime: getQuarterDates(new Date()).thisQuarterDate,
  },
  {
    label: DateFilter.Last_Qtr,
    dateTime: getQuarterDates(new Date()).lastQuarterDate,
  },
  {
    label: DateFilter.This_Year,
    dateTime: {
      startDate: new Date(moment().startOf('year').toDate()),
      endDate: new Date(moment().format('YYYY-MM-DD')),
    },
  },
  {
    label: DateFilter.Last_Year,
    dateTime: {
      startDate: new Date(
        moment().clone().subtract(1, 'year').startOf('year').toDate()
      ),
      endDate: new Date(
        moment().clone().subtract(1, 'year').endOf('year').toDate()
      ),
    },
  },

  {
    label: DateFilter.CUSTOM_DATE,
    dateTime: {
      startDate: new Date(moment().format('YYYY-MM-DD')),
      endDate: new Date(moment().format('YYYY-MM-DD')),
    },
  },
];

export const ReportDayBookDefaultOptionsArray = [
  {
    label: DateFilter.TODAY,
    dateTime: {
      startDate: new Date(moment().format('YYYY-MM-DD')),
      endDate: new Date(moment().format('YYYY-MM-DD')),
    },
  },
  {
    label: DateFilter.YESTERDAY,
    dateTime: {
      startDate: new Date(moment().subtract(1, 'days').format('YYYY-MM-DD')),
      endDate: new Date(moment().subtract(1, 'days').format('YYYY-MM-DD')),
    },
  },
  {
    label: DateFilter.This_Week,
    dateTime: {
      startDate: new Date(moment().startOf('week').toDate()),
      endDate: new Date(moment().format('YYYY-MM-DD')),
    },
  },

  {
    label: DateFilter.Last_Week,
    dateTime: {
      startDate: new Date(
        moment().subtract(1, 'weeks').startOf('week').add(1, 'days').toDate()
      ),
      endDate: new Date(
        moment().subtract(1, 'weeks').endOf('week').add(1, 'days').toDate()
      ),
    },
  },
];

export const customStaticRanges = createStaticRanges([
  {
    label: 'Today',
    range: () => ({
      startDate: new Date(),
      endDate: new Date(),
      key: 'selection',
      label: 'Today',
    }),
  },
  {
    label: 'Yesterday',
    range: () => ({
      startDate: subDays(new Date(), 1),
      endDate: subDays(new Date(), 1),
      key: 'selection',
      label: 'Yesterday',
    }),
  },
  {
    label: 'This Week',
    range: () => ({
      startDate: new Date(moment().startOf('week').toDate()),
      endDate: new Date(moment().endOf('week').toDate()),
      key: 'selection',
      label: 'This Week',
    }),
  },
  {
    label: 'Last Week',
    range: () => ({
      startDate: new Date(
        moment().subtract(1, 'weeks').startOf('week').toDate()
      ),
      endDate: new Date(moment().subtract(1, 'weeks').endOf('week').toDate()),
      key: 'selection',
      label: 'Last Week',
    }),
  },
  {
    label: 'This Month Till Date',
    range: () => ({
      startDate: new Date(moment().startOf('month').toDate()),
      endDate: new Date(moment().format('YYYY-MM-DD')),
      key: 'selection',
      label: 'This Month',
    }),
  },
  {
    label: 'Last Month',
    range: () => ({
      startDate: new Date(
        moment().clone().subtract(1, 'month').startOf('month').toDate()
      ),
      endDate: new Date(
        moment().clone().subtract(1, 'month').endOf('month').toDate()
      ),
      label: 'Last Month',
    }),
  },
  {
    label: 'This QTR Till Date',
    range: () => ({
      startDate: getQuarterDates(new Date()).thisQuarterDate.startDate,
      endDate: getQuarterDates(new Date()).thisQuarterDate.endDate,
      key: 'selection',
      label: 'This QTR',
    }),
  },
  {
    label: 'Last QTR',
    range: () => ({
      startDate: getQuarterDates(new Date()).lastQuarterDate.startDate,
      endDate: getQuarterDates(new Date()).lastQuarterDate.endDate,
      key: 'selection',
      label: 'Last QTR',
    }),
  },
  {
    label: 'This Year Till Date',
    range: () => ({
      startDate: new Date(moment().startOf('year').toDate()),
      endDate: new Date(),
      key: 'selection',
      label: 'This Year',
    }),
  },
  {
    label: 'Last Year',
    range: () => ({
      startDate: new Date(
        moment().clone().subtract(1, 'year').startOf('year').toDate()
      ),
      endDate: new Date(
        moment().clone().subtract(1, 'year').endOf('year').toDate()
      ),
      key: 'selection',
      label: 'Last Year',
    }),
  },
]);

export function getDateFilter(startDate: Date, endDate: Date): DateFilter {
  const today = moment().startOf('day');
  const yesterday = moment().subtract(1, 'day').startOf('day');

  // Week starts from Sunday and ends on Saturday
  const thisWeekStart = moment().startOf('week'); // Sunday start
  const thisWeekEnd = moment().endOf('week'); // Saturday end
  const lastWeekStart = thisWeekStart.clone().subtract(1, 'week');
  const lastWeekEnd = thisWeekEnd.clone().subtract(1, 'week');

  const thisMonthStart = moment().startOf('month');
  const thisMonthEnd = moment().endOf('month');
  const lastMonthStart = thisMonthStart.clone().subtract(1, 'month');
  const lastMonthEnd = lastMonthStart.clone().endOf('month');

  function getQuarterDates(date: moment.Moment) {
    const startOfQuarter = date.clone().startOf('quarter');
    const endOfQuarter = date.clone().endOf('quarter');
    const lastQuarterStart = startOfQuarter.clone().subtract(1, 'quarter');
    const lastQuarterEnd = lastQuarterStart.clone().endOf('quarter');

    return {
      thisQuarterDate: { startDate: startOfQuarter, endDate: endOfQuarter },
      lastQuarterDate: { startDate: lastQuarterStart, endDate: lastQuarterEnd },
    };
  }

  const { thisQuarterDate, lastQuarterDate } = getQuarterDates(moment());

  const thisYearStart = moment().startOf('year');
  const thisYearEnd = moment().endOf('year');
  const lastYearStart = thisYearStart.clone().subtract(1, 'year');
  const lastYearEnd = lastYearStart.clone().endOf('year');

  const start = moment(startDate).startOf('day');
  const end = moment(endDate).startOf('day');

  // Convert dates to string format for date-only comparison
  const format = 'YYYY-MM-DD';
  const startStr = start.format(format);
  const endStr = end.format(format);

  if (startStr === today.format(format) && endStr === today.format(format))
    return DateFilter.TODAY;
  if (
    startStr === yesterday.format(format) &&
    endStr === yesterday.format(format)
  )
    return DateFilter.YESTERDAY;
  if (
    startStr === thisWeekStart.format(format) &&
    endStr === thisWeekEnd.format(format)
  )
    return DateFilter.This_Week;
  if (
    startStr === lastWeekStart.format(format) &&
    endStr === lastWeekEnd.format(format)
  )
    return DateFilter.Last_Week;
  if (
    startStr === thisMonthStart.format(format) &&
    endStr === today.format(format)
  )
    return DateFilter.This_Month;
  if (
    startStr === lastMonthStart.format(format) &&
    endStr === lastMonthEnd.format(format)
  )
    return DateFilter.Last_Month;
  if (
    startStr === thisQuarterDate.startDate.format(format) &&
    endStr === today.format(format)
  )
    return DateFilter.This_Qtr;
  if (
    startStr === lastQuarterDate.startDate.format(format) &&
    endStr === lastQuarterDate.endDate.format(format)
  )
    return DateFilter.Last_Qtr;
  if (
    startStr === thisYearStart.format(format) &&
    endStr === thisYearEnd.format(format)
  )
    return DateFilter.This_Year;
  if (
    startStr === lastYearStart.format(format) &&
    endStr === lastYearEnd.format(format)
  )
    return DateFilter.Last_Year;

  return DateFilter.CUSTOM_DATE;
}
